<template>
  <b-container class="mw-100 px-0">
    <RecProductionReport ref="reportRef" />
  </b-container>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import RecProductionReport from '@components/RecProductionReport'

export default defineComponent({
  name: 'Reconciliation',
  components: {
    RecProductionReport
  },
  // Lives here, not in RecProductionReport itself: vue-router only calls in-component navigation
  // guards on the component a route actually matches, and this page IS that component for
  // /reconciliation - RecProductionReport is only a nested child, so the same guard defined there
  // never fired (reported bug: clicking a top-nav tab mid-edit left the page with no warning).
  // guardUnsavedChanges is returned from RecProductionReport's own setup(), so it's reachable
  // straight off the template ref; it pops the unsaved-changes modal and stashes `next`
  // (vue-router's own "proceed" callback) as the retry action, so Save/Discard in that modal calls
  // next() once the edits are actually resolved, and Cancel simply never calls it (staying put).
  // Optional-chaining the ref covers the modal's own teardown order - if the child is already gone
  // there's nothing unsaved left to guard, so navigation just proceeds.
  beforeRouteLeave(to, from, next) {
    const report = this.$refs.reportRef

    if (report && report.guardUnsavedChanges(() => next())) return

    next()
  }
})
</script>
